import * as React from "react";
import { httpRequest } from "../services/httpService";
import { routerPath } from "../config/constents";
import { useStateValue } from "../providers/stateProvider";

export interface PropRoute {
  path: string;
  element?: React.ReactNode | null;
}
// vendor Details API
export const saveVendorDetails = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertUpdateVendor, formData);
};

export const getVendorDetails = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getVendor + "?lCorporateId=" + CorporateDetailsId
  );
};
export const getVendorDetailsForGrid = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getVendorForGrid +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};

// export const getproductmaster = (formData: any) => {
//   const url = `${routerPath.API.config.productmaster}?PageNumber=${formData?.PageNumber}`;
//   return httpRequest.get(url);
// };

export const getproductmaster = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.productmaster + "?lCorporateId=" + CorporateDetailsId
  );
};
export const getproductmasterforgrid = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.productmasterForGrid +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};

export const getMisTypemasterforDropdown = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.MisMasterForDropdown +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};

export const getMisFilterDataforcase = (formData: any, precaseType: any) => {
  return httpRequest.post(
    routerPath.API.config.getMisFilterDataforcase + "?precaseType=" + precaseType,
    formData
  );
};

export const getMisFilterDataforcaseForExcel = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.getMisFilterDataforcaseForExcel,
    formData
  );
};

export const getMisFilterDataforExport = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.getMisFilterDataforExport,
    formData
  );
};

export const getReportBranding = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getReportBranding + "?lCorporateId=" + lCorporateId
  );
};

export const uploadReportLogo = (lCorporateId: any, file: File) => {
  const formData = new FormData();
  formData.append("lCorporateId", String(lCorporateId));
  formData.append("file", file);
  return httpRequest.post(routerPath.API.config.uploadReportLogo, formData);
};

export const downloadPreCaseReport = (caseID: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.downloadPreCaseReport +
      "?caseID=" + caseID + "&lCorporateId=" + lCorporateId
  );
};

export const getprecasedataforbindgrid = () => {
  return httpRequest.get(routerPath.API.config.getAllMisReportData);
};
export const getVendornames = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getvendornames + "?lCorporateId=" + CorporateDetailsId
  );
};
export const getVendornamesInput = (UserID: any, CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getvendornamesInput +
    "?UserID=" +
    UserID +
    "&lCorporateId=" +
    CorporateDetailsId
  );
};
export const getbanknames = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getbanknames + "?lCorporateId=" + CorporateDetailsId
  );
};
export const getsegmentnames = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getsegmentnames +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};

export const getEmployeeType = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getEmployeeType +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getAddressTypes = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAddressType + "?lCorporateId=" + CorporateDetailsId
  );
};
export const getSampling = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getSamplingDetail +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getStaffDetails = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getStaffName + "?lCorporateId=" + CorporateDetailsId
  );
};

export const getProducts = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getProductNames +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getVerificationDet = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getVerificationDetails +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getAuthorityMaster = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAuthorityMasterDetail +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getEmployeeTypes = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getEmployeeTypeDetails +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getSamplingDetails = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getSamplingDetail +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const getAgencyNames = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAgencyNames + "?lCorporateId=" + CorporateDetailsId
  );
};
export const insertProductMaster = (formData: any) => {
  return httpRequest.post(routerPath.API.config.inserProductmaster, formData);
};
export const updateProductMaster = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updateProductmaster, formData);
};
export const searchProductMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchProductMaster +
    "?SearchValue=" +
    formData?.search +
    "&lCorporateId=" +
    formData?.CorporateDetailsId
  );
};
export const pdfProductMaster = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.pdfProductMaster +
    "?lCorporateId=" +
    CorporateDetailsId
  );
};
export const excelProductMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelProductmaster +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10 +
    "&lCorporateId=" +
    formData?.CorporateDetailsId
  );
};
// Query Master
export const insertQueryMaster = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertQueryMaster, formData);
};
export const updateQueryMaster = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updateQueryMaster, formData);
};
export const searchQueryMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchQueryMaster +
    "?SearchValue=" +
    formData?.search +
    "&lCorporateId=" +
    formData?.CorporateDetailsId
  );
};
export const pdfQueryMaster = (CorporateDetailsId: any) => {
  return httpRequest.get(
    routerPath.API.config.pdfQueryMaster + "?lCorporateId=" + CorporateDetailsId
  );
};
export const excelQueryMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelQueryMaster +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10 +
    "&lCorporateId=" +
    formData?.CorporateDetailsId
  );
};
export const getAllQueryMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllQueryMaster +
    "?PageNumber=" +
    formData?.PageNumber +
    "&lCorporateId=" +
    formData?.CorporateDetailsId
  );
};
//Hub Master

export const insertHubMaster = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertHubMaster, formData);
};
export const insertSmtpMaster = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertSmtpMaster, formData);
};
export const updateHubMaster = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updateHubMaster, formData);
};
export const updatesmtpdetails = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updatesmtpdetails, formData);
};
export const searchHubMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchHub + "?SearchValue=" + formData?.search
  );
};
export const getQueryList = (_type: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getquerylist +
    `?ProfileType=${_type}` +
    `&lCorporateId=${lCorporateId}`
  );
};
export const getAllHubMaster = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllHub + "?lCorporateId=" + lCorporateId
  );
};
export const EditSmtpDetails = (smtpId: any) => {
  return httpRequest.get(
    routerPath.API.config.EditSmtpDetails + "?smtpId=" + smtpId
  );
};
export const getAllSMTPForGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllSMTPForGrid + "?lCorporateId=" + lCorporateId
  );
};
export const getDesignationList = () => {
  return httpRequest.get(routerPath.API.config.getDesignationList);
};
export const gethubdetails = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.gethubdetails + "?lCorporateId=" + lCorporateId
  );
};
export const getAllHubMasterAll = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllHubAll + "?lCorporateId=" + lCorporateId
  );
};
//User Master Details
export const inserUserMaster = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertmasterDeatils, formData);
};

export const getUserType = (lCorporateId: any) => {
  const corpId = lCorporateId ?? 0;
  return httpRequest.get(
    routerPath.API.config.getUserType + "?lCorporateId=" + corpId
  );
};
export const getUserRole = (lCorporateId: any) => {
  const corpId = lCorporateId ?? 0;
  return httpRequest.get(
    routerPath.API.config.getUserRole + "?lCorporateId=" + corpId
  );
};
export const deleteIMEIUser = (id: any) => {
  return httpRequest.post(
    routerPath.API.config.deleteUserImei + "?ID=" + id + "&lCorporateId=0"
  );
};

export const getAllUserMaster = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getUserMaster + "?lCorporateId=" + lCorporateId
  );
};

// Bank--- Configuration
export const insertBank = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertBankDetails, formData);
};
export const getAllBanks = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllBanks + "?lCorporateId=" + lCorporateId
  );
};
export const getAllBankForGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllBanksForGrid + "?lCorporateId=" + lCorporateId
  );
};
export const updateBank = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updateBankDetails, formData);
};


export const InsertOrUpdateBank = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertOrUpdateBankDetails, formData);
};

export const getConfigBankForGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getConfigBankForGrid + "?lCorporateId=" + lCorporateId
  );
};

export const editBankDetails = (bankId: any) => {
  return httpRequest.get(
    routerPath.API.config.editBankDetails + "?bankId=" + bankId
  );
};

export const getquerytype = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getquerytype + "?lCorporateId=" + lCorporateId
  );
};


//Branch--- Configuration
export const insertBranch = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertBranchDetails, formData);
};
export const updateBranch = (formData: any) => {
  return httpRequest.put(routerPath.API.config.updateBranchDetails, formData);
};
export const searchBranch = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchBranchs +
    "?SearchValue=" +
    formData?.search +
    "&lCorporateId=" +
    formData?.lCorporateId
  );
};
export const pdfBranch = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.pdfBranch + "?lCorporateId=" + lCorporateId
  );
};
export const excelBranch = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelBranch +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10 +
    "&lCorporateId=" +
    formData?.lCorporateId
  );
};
export const getAllBranch = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllBranchs + "?lCorporateId=" + lCorporateId
  );
};
export const getAllBranchForGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllBranchsForGrid + "?lCorporateId=" + lCorporateId
  );
};
export const getAllBranchsByBankId = (bankid: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllBranchsByBankId + "?bankid=" + bankid
  );
};
//Holiday Master Configuration

export const insertHolidayMaster = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertHolidayMasterDetails,
    formData
  );
};
export const updateHolidayMaster = (formData: any) => {
  return httpRequest.put(
    routerPath.API.config.updateHolidayMasterDetails,
    formData
  );
};
export const searchHolidayMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchHolidayMaster +
    "?SearchValue=" +
    formData?.search
  );
};
export const pdfHolidayMaster = () => {
  return httpRequest.get(routerPath.API.config.pdfHoliday);
};
export const excelHolidayMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelHoliday +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10
  );
};
export const getAllHolidayMaster = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllHolidayMaster + "?lCorporateId=" + lCorporateId
  );
};

//Route Master Configuration

export const insertRouteMaster = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertRouteMasterDetails,
    formData
  );
};
export const updateRouteMaster = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.updateRouteMasterDetails,
    formData
  );
};
export const routeMasterAssignTo = (formData: any) => {
  return httpRequest.post(routerPath.API.config.routeMasterAssignTo, formData);
};
export const searchRouteMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchRouteMaster + "?SearchValue=" + formData?.search
  );
};
export const pdfRouteMaster = () => {
  return httpRequest.get(routerPath.API.config.pdfRouteMaster);
};
export const excelRouteMaster = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelRouteMaster +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10
  );
};
export const getAllRouteMaster = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllRouteMasterDetails +
    "?lCorporateId=" +
    lCorporateId
  );
};

export const getAllRouteMasterforAssign = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllRouteMasterDetails +
    "?lCorporateId=" +
    lCorporateId
  );
};

//Route Assingment Configuration

export const insertRouteAssign = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertRouteAssignDetails,
    formData
  );
};
export const updateRouteAssign = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.updateRouteAssignDetails,
    formData
  );
};
export const searchRouteAssign = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.searchRouteAssign + "?SearchValue=" + formData?.search
  );
};

export const getPincodeList = (FormData: any) => {
  return httpRequest.get(
    routerPath.API.config.getPincodeByRoute +
    "?routename=" +
    FormData?.routeNme +
    "&lCorporateId=" +
    FormData?.lCorporateId
  );
};
export const pdfRouteAssign = () => {
  return httpRequest.get(routerPath.API.config.pdfRouteAssign);
};

export const excelRouteAssign = (formData: any) => {
  return httpRequest.get(
    routerPath.API.config.excelRouteAssign +
    "?PageNumber=" +
    formData?.PageNumber +
    "&PageSize=" +
    10
  );
};
export const getAllRouteAssign = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllRouteAssignDetails +
    "?lCorporateId=" +
    lCorporateId
  );
};
export const getAllRouteAssignGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllRouteAssignDetailsGrid +
    "?lCorporateId=" +
    lCorporateId
  );
};

export const getAllStaffDetails = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.getAllStaffDetails +
    "?lCorporateId=" + encodeURIComponent(lCorporateId ?? "") 
    // "&CorporateDetailsId=" + encodeURIComponent(lCorporateId ?? "")
  );
};

//Product Detail -- Configuration

export const insertProductDetail = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertProductDetails, formData);
};
export const updateProductDetail = (formData: any) => {
  return httpRequest.post(routerPath.API.config.updateProductDetails, formData);
};
export const getAllProductDetail = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllProductDetails + "?lCorporateId=" + lCorporateId
  );
};
export const getAllProductDetailGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllProductDetailsGrig +
    "?lCorporateId=" +
    lCorporateId
  );
};

//Tat Matrix Configuration

export const getBankByVendorId = (formData: any) => {
  const url =
    `${routerPath.API.config.getBankByVendorId}?vendorId=${formData?.VendorId}` +
    `&lCorporateId=${formData?.lCorporateId}`;
  return httpRequest.get(url);
};

export const getBranchByBankId = (formData: any) => {
  const url =
    `${routerPath.API.config.getBranchByBankId}?BankId=${formData?.BankId}` +
    `&lCorporateId=${formData?.lCorporateId}`;
  return httpRequest.get(url);
};
export const getBranchByBranchId = (BranchId: any) => {
  const url = `${routerPath.API.config.getProductNamebyBranch}?BranchId=${BranchId}`;
  return httpRequest.get(url);
};

export const getTypeByProductId = (productID: any, lCorporateId: any, bankId: any) => {
  const url =
    `${routerPath.API.config.getTypeByProduct}?productID=${productID}` +
    `&lCorporateId=` +
    lCorporateId +
    `&bankId=` + bankId;
  return httpRequest.get(url);
};

export const getProductByBankandBranchId = (formData: any) => {
  const url =
    `${routerPath.API.config.getProductNamebyBankandBranch}?BankId=${formData?.BankId}` +
    `&lCorporateId=${formData?.lCorporateId}`;
  return httpRequest.get(url);
};

export const insertTatMatrix = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertTatMatrix, formData);
};
export const updateTatMatrix = (formData: any) => {
  return httpRequest.post(routerPath.API.config.updateTatMatrix, formData);
};

export const getAllTatMatrix = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllTatMatrix + "?lCorporateId=" + lCorporateId
  );
};
export const getAllTatMatrixForGrid = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllTatMatrixForGrid +
    "?lCorporateId=" +
    lCorporateId
  );
};

//SegmentMaster Configuration

export const insertSegmentDetail = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertSegment, formData);
};
export const updateSegmentDetail = (formData: any) => {
  return httpRequest.post(routerPath.API.config.updateSegment, formData);
};
export const getAllSegment = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllSegment + "?lCorporateId=" + lCorporateId
  );
};

export const getStaffDetail = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getStaffDetails + "?lCorporateId=" + lCorporateId
  );
};

export const insertStaffDetails = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertStaffDetails, formData);
};

export const updateStaffDetails = (formData: any) => {
  return httpRequest.post(routerPath.API.config.updateStaffDetails, formData);
};

export const getManagerList = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getManagerList + "?lCorporateId=" + lCorporateId
  );
};

export const getAllPrecaseInspectionData = (
  userid: any,
  pageNumber: any,
  pageSize: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getallPrecaseInspectionData +
    "?caseType=precase&UserID=" +
    userid +
    "&pageNumber=" +
    pageNumber +
    "&pageSize=" +
    pageSize +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const getAllInspectionDataPre = (caseid: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getallInspectionData +
    "?caseType=precase&caseID=" +
    caseid +
    "&lCorporateId=" +
    lCorporateId +
    "&precaseTypes=CPV"
  );
};
export const getAllInspectionDataPost = (caseid: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getallInspectionData +
    "?caseType=postcase&caseID=" +
    caseid +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const updateInspectionData = (formdata: any) => {
  return httpRequest.put(routerPath.API.config.updateInspectionData, formdata);
};

export const updateInspectionDataCopy = (formdata: any) => {
  return httpRequest.put(routerPath.API.config.updateInspectionDataCopy, formdata);
};

export const updateInspectionDataCopyCPV = (formdata: any) => {
  return httpRequest.put(routerPath.API.config.updateInspectionDataCopyCPV, formdata);
};

export const updateQCInspectionData = (formdata: any) => {
  return httpRequest.put(
    routerPath.API.config.updateQCInspectionData,
    formdata
  );
};

export const getAllPostcaseInspectionData = (
  UserId: any,
  pageNumber: any,
  pageSize: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getallPostcaseInspectionData +
    "?caseType=postcase&UserID=" +
    UserId +
    "&pageNumber=" +
    pageNumber +
    "&pageSize=" +
    pageSize +
    "&lCorporateId=" +
    lCorporateId
  );
};

export const getAllPrecaseqcInspectionData = (
  pageNumber: any,
  pageSize: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getallPrecaseQcInspectionData +
    "?caseType=precase&pageNumber=" +
    pageNumber +
    "&pageSize=" +
    pageSize +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const getallQcInspectionDataPre = (caseid: any) => {
  return httpRequest.get(
    routerPath.API.config.getallQcInspectionData +
    "?caseType=precase&caseID=" +
    caseid
  );
};

export const getallQcInspectionDataPost = (caseid: any) => {
  return httpRequest.get(
    routerPath.API.config.getallQcInspectionData +
    "?caseType=postcase&caseID=" +
    caseid
  );
};
export const getAllPostcaseqcInspectionData = (
  pageNumber: any,
  pageSize: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getallPostcaseQcInspectionData +
    "?caseType=postcase&pageNumber=" +
    pageNumber +
    "&pageSize=" +
    pageSize +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const getAllMisReportData = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllMisReportData + "?lCorporateId=" + lCorporateId
  );
};
export const getMISforXcellDownload = (
  caseType: string,
  UserID: number,
  PageName: string,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getMISforAllTray +
    "?caseType=" +
    caseType +
    "&UserID=" +
    UserID +
    "&PageName=" +
    PageName +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const getallgetbackofficestatus = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getallgetbackofficestatus +
    "?lCorporateId=" +
    lCorporateId
  );
};
export const deleteDocument = (formdata: any) => {
  return httpRequest.post(routerPath.API.config.deleteDocument, formdata);
};
export const savecaseDoc = (formdata: any) => {
  return httpRequest.post(routerPath.API.config.saveCaseDocument, formdata);
};

export const getStateDetails = (lCorporateId: any) => {
  const corpId = lCorporateId ?? 0;
  return httpRequest.get(
    routerPath.API.config.getStateList + "?lCorporateId=" + corpId
  );
};

export const getFieldExecutiveName = (formData: any) => {
  debugger;
  const url = `${routerPath.API.config.getFieldExecutiveName}?HubId=${formData?.HubId}&pincode=${formData?.pincode}&lCorporateId=${formData?.lCorporateId}`;
  return httpRequest.get(url);
};
export const getEmployeeDocTypes = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getEmployeeDocDetails +
    "?lCorporateId=" +
    lCorporateId
  );
};
export const insertRouteMasterWithFile = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertRouteMasterDetailsWithFile,
    formData
  );
};

export const bulkUploadPreAndPost = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.bulkUploadPreAndPostCase,
    formData
  );
};
export const bulkUploadPostCase = (formData: any) => {
  return httpRequest.post(routerPath.API.config.bulkUploadPostCase, formData);
};
export const insertAccess = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertAccessManagement,
    formData
  );
};
export const updateAccess = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.updateAccessManagement,
    formData
  );
};
export const getAccessDetails = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAccessManagement + "?lCorporateId=" + lCorporateId
  );
};

//Case Reassignment
export const getCaseDetaislforReassign = (formData: any) => {
  const url =
    `${routerPath.API.config.getCaseInfoforreassign}?caseType=${formData?.CaseType}` +
    `&lCorporateId=${formData.lCorporateId}`;
  return httpRequest.get(url);
};
export const updateCaseAssign = (formData: any) => {
  const url = `${routerPath.API.config.updateCaseAssign}?caseType=${formData?.caseType}&caseID=${formData?.caseID}&hubID=${formData?.hubID}&staffID=${formData.staffID}&staffname=${formData.staffname}&lCorporateId=`;
  return httpRequest.get(url);
  // return httpRequest.get(routerPath.API.config.updateCaseAssign+"?caseType=");
};
export const getFieldstaffbyHubid = (formData: any) => {
  const url = `${routerPath.API.config.getfieldstaffbyhubid}?caseType=${formData?.caseType}&caseID=${formData?.caseID}&hubID=${formData?.hubID}&staffID=${formData.staffID}&staffname=${formData.staffname}&lCorporateId=`;
  return httpRequest.get(url);
};
export const getFieldStaffList = (formData: any) => {
  const url = `${routerPath.API.config.getFieldStaffList}?hubID=${formData?.hubId}&lCorporateId=`;
  return httpRequest.get(url);
};
export const getCustomerDocTypes = (type: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getCustomerDocType +
    `?personnel=${type}&lCorporateId=${lCorporateId}`
  );
};

export const getAllFieldStaff = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllFieldStaff + "?lCorporateId=" + lCorporateId
  );
};

export const deletePincode = (ID: any, lCorporateId: any) => {
  return httpRequest.post(
    routerPath.API.config.removePincode +
    "?ID=" +
    ID +
    "&lCorporateId=" +
    lCorporateId
  );
};

export const generatePreCasePDF = (
  caseID: any,
  caseType: any,
  lCorporateId: any,
  precaseType: any,
) => {
  return httpRequest.get(
    routerPath.API.config.getPDF +
    "?caseID=" +
    caseID +
    "&caseType=" +
    caseType +
    "&lCorporateId=" +
    lCorporateId +
    "&precaseType=" + precaseType
  );
};
export const generatePostCasePDF = (
  caseID: any,
  caseType: any,
  lCorporateId: any,
  precaseType: any
) => {
  return httpRequest.get(
    routerPath.API.config.getPDF +
    "?caseID=" +
    caseID +
    "&caseType=" +
    caseType +
    "&lCorporateId=" +
    lCorporateId +
    "&precaseType=" + precaseType
  );
};
export const generateTotalPostCasePDF = (
  caseID: any,
  caseType: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getTotalPDF +
    "?caseID=" +
    caseID +
    "&caseType=" +
    caseType +
    "&lCorporateId=" +
    lCorporateId
  );
};
export const generateTotalPreCasePDF = (
  caseID: any,
  caseType: any,
  lCorporateId: any
) => {
  return httpRequest.get(
    routerPath.API.config.getTotalPDF +
    "?caseID=" +
    caseID +
    "&caseType=" +
    caseType +
    "&lCorporateId=" +
    lCorporateId
  );
};

export const getKycDocType = (lCorporateId: any, sProvider: any) => {
  return httpRequest.get(
    routerPath.API.config.getKycDocType + "?lCorporateId=" + lCorporateId + "&sProvider=" + sProvider
  );
};
export const getBascicAmount = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getBasicAmount + "?corporateId=" + lCorporateId
  );
};
export const getPaymentgetwayKey = () => {
  return httpRequest.get(routerPath.API.config.getPaymentgetWayKey);
};
export const postcardPayment = (
  totalAmount: any,
  paymentGatewayKey: any,
  paymentGatewaySecret: any
) => {
  return httpRequest.post(
    routerPath.API.config.cardPayment +
    "?TotalAmount=" +
    totalAmount +
    "&PaymentGatewayKey=" +
    paymentGatewayKey +
    "&paymentGatewaySecret=" +
    paymentGatewaySecret
  );
};
export const insertAmount = (corporateId: any, amount: any) => {
  return httpRequest.post(
    routerPath.API.config.insertorUpdateWallet +
    "?corporateId=" +
    corporateId +
    "&amount=" +
    amount
  );
};
export const insertwalletTransaction = (
  corporatewalletId: any,
  amount: any,
  transNo: any,
  transJason: any
) => {
  return httpRequest.post(
    routerPath.API.config.insertorUpdateWalletTransaction +
    "?corporatewalletId=" +
    corporatewalletId +
    "&amount=" +
    amount +
    "&transNo=" +
    transNo +
    "&transJason=" +
    transJason
  );
};

export const getKycPan = (formParams: any, formData: any) => {
  return httpRequest.post(
    routerPath.API.config.getKycPan +
    `?userid=${formParams?.id}&TypeId=${formParams?.typeId}&lCorporateId=${formParams?.lCorporateId}`,
    formData
  );
};

export const getSandboxKycDetails = (formParams: any, formData: any) => {
  return httpRequest.post(
    routerPath.API.config.getSandboxKycDetails +
    `?userid=${formParams?.id}&TypeId=${formParams?.typeId}&lCorporateId=${formParams?.lCorporateId}`,
    formData
  );
};

export const gekycUsageReport = () => {
  return httpRequest.get(routerPath.API.config.getKycUsageReport);
};

export const getBackOfficeCaseGridData = (
  fromDate: any,
  toDate: any,
  userID: any,
  lCorporateId: any,
  caseType: any
) => {
  return httpRequest.get(
    routerPath.API.config.getallBackOfficeData +
    "?startDate=" +
    fromDate +
    "&endDate=" +
    toDate +
    "&UserID=" +
    userID +
    "&lCorporateId=" +
    lCorporateId +
    "&caseType=" +
    caseType
  );
};

export const getQcCaseGridData = (
  fromDate: any,
  toDate: any,
  UserID: any,
  lCorporateId: any,
  caseType: any

) => {
  return httpRequest.get(
    routerPath.API.config.getallQcData +
    "?startDate=" +
    fromDate +
    "&endDate=" +
    toDate +
    "&UserID=" +
    UserID +
    "&lCorporateId=" +
    lCorporateId +
    "&caseType=" +
    caseType
  );
};

export const getProductForDropdown = (lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getProductForDropdown +
    "?lCorporateId=" +
    lCorporateId
  );
};
//Service Request
export const inserNewRequest = (formData: any) => {
  return httpRequest.post(routerPath.API.config.insertNewrequest, formData);
};
export const getallRequestDetails = (id: any) => {
  return httpRequest.get(routerPath.API.config.getAllrequest + "?id=" + id);
};
export const getAllEmployee = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getContributorRoleTypes + "?corporateId=" + corporateId
  );
};
export const getAllCommission = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetCommission + "?corporateId=" + corporateId
  );
};

export const inserCommission = (formData: any) => {
  return httpRequest.post(routerPath.API.config.InsertCommission, formData);
};
export const getallDocumentDetails = (id: any) => {
  return httpRequest.get(
    routerPath.API.config.getallDocumentDetails + "?id=" + id
  );
};

export const getSubServices = (serviceId: any) => {
  return httpRequest.get(
    routerPath.API.config.getSubServices + "?serviceId=" + serviceId
  );
};

export const insertservicecatalgue = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertservicecatalgue,
    formData
  );
};

export const getAllPaymentFromVerifyon = () => {
  return httpRequest.get(routerPath.API.config.getAllPaymentFromVerifyon);
};

export const getAllCommissionPayout = () => {
  return httpRequest.get(routerPath.API.config.getAllCommissionPayout);
};

export const insertservicecatalgueEdu = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertservicecatalgueEdu,
    formData
  );
};

export const getStateLists = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getStateLists + "?corporateId=" + corporateId
  );
};

export const getuniversityLists = (id: any) => {
  return httpRequest.get(
    routerPath.API.config.getuniversityLists + "?id=" + id
  );
};

export const getGridBindDetails = (corporateId: any, type: any) => {
  return httpRequest.get(
    routerPath.API.config.getGridBindDetails + "?corporateId=" + corporateId + "&type=" + type
  );
};

export const getAllGridBindDetails = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.getAllGridBindDetails + "?corporateId=" + corporateId
  );
};

export const GetCorporateDashBoardData = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetCorporateDashBoardData + "?corporateId=" + corporateId
  );
};

export const EditBindDetails = (id: any) => {
  return httpRequest.get(
    routerPath.API.config.EditBindDetails + "?id=" + id
  );
};

export const UserrequestGridBind = (corporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.UserrequestGridBind + "?corporateId=" + corporateId
  );
};

export const getCustomerRequestDetailsbyId = (verificationRequestId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetCustomerRequestDetailsbyId +
    "?verificationRequestId=" + verificationRequestId
  );
};

export const getVerifierNameByPincode = (pincode: any) => {
  return httpRequest.get(
    routerPath.API.config.getverifiername + "?pincode=" + pincode
  );
};

export const updateVerifierDetails = (customerRequestId: any, verifierId: any) => {
  return httpRequest.post(
    routerPath.API.config.UpdateVerifierDetails +
    "?customerRequestId=" + customerRequestId +
    "&verifierId=" + verifierId
  );
};

export const customerreqbackofficegridbind = (corporateDetailsId: any, statusId: any) => {
  return httpRequest.get(
    routerPath.API.config.customerreqbackofficegridbind + "?corporateDetailsId=" + corporateDetailsId + "&statusId=" +
    statusId
  );
};

export const viewcustomerrequestData = (verificationId: any) => {
  return httpRequest.get(
    routerPath.API.config.viewcustomerrequestData + "?verificationId=" + verificationId
  );
};

export const updaterequestcaseStatus = (verificationId: any, statusId: any, overallstatus: any, remarks: any) => {
  return httpRequest.post(
    routerPath.API.config.updaterequestcaseStatus + "?verificationId=" + verificationId + "&statusId=" +
    statusId + "&overallstatus=" +
    overallstatus + "&remarks=" +
    remarks
  );
};

// Employment 

export const insertorUpdateEmployementDetails = (formData: any) => {
  return httpRequest.post(
    routerPath.API.config.insertorUpdateEmployementDetails,
    formData
  );
};


//CPV (Address Verification)
export const getHubbylocationandpincode = (pincode: any, location: any) => {
  return httpRequest.get(
    routerPath.API.config.getHubbylocationandpincode + "?pincode=" + pincode + "&location=" + location
  );
};

export const getFieldExecutive = () => {
  return httpRequest.get(routerPath.API.config.getUserDropdown);
};

export const getProductByBank = (bankId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetProductByBank + "?bankId=" + bankId
  );
};
export const getFieldStaffByBankId = (bankId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetFieldstaffbyBankId + "?bankId=" + bankId
  );
};


export const getAllQcStatusData = () => {
  return httpRequest.get(routerPath.API.config.getallstatus);
};

export const getQASummaryFromGemini = (formData: any) => {
  const url =
    `${routerPath.API.config.getQASummaryFromGemini}?caseId=${formData?.caseId}` +
    `&lCorporateId=${formData?.lCorporateId}`;
  return httpRequest.get(url);
};


export const UpdateMapping = (formData: any) => {
  return httpRequest.post(routerPath.API.config.UpdateUserMapping, formData);
};


export const editUserMapping = (lCorporateId: any, id: any) => {
  return httpRequest.get(
    routerPath.API.config.EditUserMapping + "?lCorporateId=" + lCorporateId + "&id=" + id);
};

export const DeleteSubProduct = (subproductId: any) => {
  return httpRequest.get(
    routerPath.API.config.DeleteSubProduct + "?subproductId=" + subproductId
  );
};

export const GetSubProductByProductId = (productId: any) => {
  return httpRequest.get(
    routerPath.API.config.GetSubProductByProductId + "?productId=" + productId
  );
};

export const edit_productmasterdetails = (id: any, lCorporateId: any) => {
  return httpRequest.get(
    routerPath.API.config.edit_productmasterdetails + "?id=" + id + "&lCorporateId=" + lCorporateId
  );
};

export const lookupPincode = (pin: string) => {
  return httpRequest.get(routerPath.API.config.lookupPincode + pin);
};
